// Design tokens: defines the --tl-* custom properties + loads self-hosted fonts.
// Imported first so app styles can still override; nothing consumes the tokens yet.
import '@repo/design-tokens/tokens.css';
// Global CSS reset (formerly `@tailwind base`); loads before App.css so app styles override it.
import '@repo/design-tokens/preflight.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Fluent Provider
import { FluentProvider, teamsLightTheme, PartialTheme } from '@fluentui/react-components';

// Theme
import { lightTheme } from '@repo/front-end-data';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const theme: PartialTheme = {
  ...teamsLightTheme,
  ...lightTheme,
};

root.render(
  <React.StrictMode>
    <FluentProvider theme={theme}>
      <App />
    </FluentProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
